<script lang="ts">
    import {Flex, KpLoadableContainer, Spacer} from 'shared/layouts';
    import type {SimpleFond, TypeOrIdentifiedStub, UUID} from 'src/typings';
    import {getInjector} from 'src/core';
    import type {ResolvedRecordFieldsDetail, RecordFieldsDetailGridOptions} from './types';
    import {resolveRecordDetailFields} from './record-fields-detail-resolver';
    import {RecordGridService} from 'src/features/record-grid/services/record-grid.service';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import RecordDetailGridField from './RecordDetailGridField.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    interface SimpleRecord {
        id: UUID;
        fond: TypeOrIdentifiedStub<SimpleFond>;
    }

    export let record: SimpleRecord | null;
    export let options: RecordFieldsDetailGridOptions = {};

    const recordGridService = getInjector().getByClass(RecordGridService);

    let loadError = false;
    let loading = true;

    let resolvedDetail: ResolvedRecordFieldsDetail;

    onMount(async () => {
        if (!exists(record)) {
            loading = false;
        }

        try {
            const fieldDefinitions = await recordGridService.loadFondFieldTypeDefinitions(record.fond);
            const recordRow = await recordGridService.loadSingleRow(record.id);

            resolvedDetail = resolveRecordDetailFields(fieldDefinitions.fieldTypes, recordRow, options);
        } catch {
            loadError = true;
        } finally {
            loading = false;
        }
    });
</script>

<Flex direction="column">
    <slot name="title-header">
        <KpHeading type="h2">Výpis polí záznamu</KpHeading>
    </slot>

    <Spacer direction="vertical" size="xxl"/>

    {#if exists(record)}
        <KpLoadableContainer {loading} {loadError}>
            <div class="record-detail-grid">
                {#each resolvedDetail.detailFields as detailField}
                    <RecordDetailGridField {detailField}/>
                {/each}
            </div>
        </KpLoadableContainer>
    {:else}
        <Flex alignItems="center" justifyContent="center">
            <IconedContent align="center" justify="center" orientation="vertical" icon="info" iconColor="var(--danger-red)">
                <slot name="null-record-text">
                    Záznam je buď null, nebo undefined.
                </slot>
            </IconedContent>
        </Flex>
    {/if}
</Flex>

<style lang="less">
    @import (reference) 'styles/portaro.variables.less';

    .record-detail-grid {
        display: grid;
        gap: @spacing-l;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    }
</style>